export default __webpack_public_path__ + "static/media/codesage.7f056639.png";